import React from "react";
import ProizvodiComponent from "../components/Products";

const ProizvodiSection = () => {
    return (
        <div id="proizvodi">
            <ProizvodiComponent />
        </div>
    );
};
export default ProizvodiSection;
